<template>
  <div>
    <h2 style="color: #0fb6fe; margin-bottom: 25px;">
      The words
    </h2>
    <pane-response-encouraging-words
        :words="encouragingWords"
    />
    <pane-response-scriptures
        :scriptures="scriptures"
    />
    <pane-response-parting-words
        :words="partingWords"
    />
    <pane-response-feedback
        style="margin-top: 15px"
        :profile="profile"
        :curr-doc="currDoc"
        :path="path"
    />
  </div>
</template>

<script>
import PaneResponseEncouragingWords from "./paneResponseEncouragingWords";
import PaneResponsePartingWords from "./paneResponsePartingWords";
import PaneResponseScriptures from "./paneResponseScriptures";
import PaneResponseFeedback from "./paneResponseFeedback";

export default {
  name: "Display_PaneResponse_WordSection",
  components: {
    PaneResponseEncouragingWords,
    PaneResponseScriptures,
    PaneResponsePartingWords,
    PaneResponseFeedback
  },
  created(){},
  mounted() {},
  props: {
    profile: {
      type: Object,
      required: false,
      default: ()=>{return {}}
    },
    currDoc: {
      type: Object,
      required: false,
      default: ()=>{return {}}
    },
    path: {
      type: String,
      required: false,
      default: ''
    },
    encouragingWords: {
      type: String,
      required: false,
      default: ""
    },
    scriptures: {
      type: Array,
      required: false,
      default: ()=>{return []}
    },
    partingWords: {
      type: String,
      required: false,
      default:""
    },
  },
  computed: {},
  methods: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
